import { types, successAction } from "@authzsvc/api-lib";

export default (state = [], action) => {
  switch (action.type) {
    case successAction(types.GET_APPLICATION_LIST_V2):
      return [...action.payload.data];
    case successAction(types.GET_ALL_APPLICATIONS_V2):
      return [...action.payload.data];
    default:
      return state;
  }
};
